

// 👇 多个游戏的共用部分
export const oGameCommon = {
    bet: {
        en: 'BET',
        cn: '押注',
    },
    cashout: {
        en: 'Cashout', // 大写形式用 str.toUpperCase 或 css 实现
        cn: '返现',
    },
    startAutoBet: {
        en: 'Start Autobet',
        cn: '开始自动押注',
    },
    stopAutoBet: {
        en: 'Stop Autobet',
        cn: '停止自动押注',
    },
    // 'lastTurn': {
    //     en: 'Last turn',
    //     cn: '最后一局',
    // },
    NumberOfBets: {
        en: 'Number of bets',
        cn: '押注数',
    },
    Onwin: {
        en: 'On win',
        cn: '赢时',
    },
    Onloss: {
        en: 'On loss',
        cn: '输时',
    },
    Reset: {
        en: 'Reset',
        cn: '重置',
    },
    Increaseby: {
        en: 'Increase by',
        cn: '每次增加',
    },
    StopOnProfit: {
        en: 'Stop on Profit',
        cn: '止盈',
    },
    StopOnLoss: {
        en: 'Stop on Loss',
        cn: '止损',
    },
    MaxBet: {
        en: 'Max bet',
        cn: '最大押注',
    },
    statisticsTitle: {
        en: 'Current page statistics',
        cn: '当前页面数据统计',
    },
    chageHall: {
        en: 'Please change to another hall',
        cn: '请更换其他大厅',
    },
    loading: {
        en: 'Loading',
        cn: '加载中',
    },
};
